// extracted by mini-css-extract-plugin
export default {"sidebar":"sidebar_sidebar__GC2vn","active_sidebar":"sidebar_active_sidebar__Jngup","close_button":"sidebar_close_button__LjWAA"};